import * as Form from "@radix-ui/react-form";
import type { ComponentPropsWithoutRef } from "react";

export const PageContainer = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">) => (
  <div
    className={`mx-auto min-h-[calc(100%-94px)] max-w-[768px] ${className ?? ""}`}
    {...props}
  />
);

export const PageFormContainer = ({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof Form.Root>) => (
  <Form.Root
    className={`flex h-full w-full flex-col items-center ${className ?? ""}`}
    {...props}
  />
);
